import cx from 'classnames';
import * as styles from '~/CreateFabricInvitation/components/NavHeader/components/NamedStepsNavWrapper.module.scss';
import {ProgressBar} from '~/CreateFabricInvitation/components/NavHeader/ProgressBar';
import {shouldUseNamedStepsNav} from '~/common/utils/event_utils';
import './ProgressHeader.sass';

interface ProgressHeaderProps {
  navElements: React.ReactNode;
  showProgressBar: boolean;
  currentStepId: number;
  totalSteps: number;
  showPreviewNav: boolean;
}

export const ProgressHeader = ({
  navElements,
  totalSteps,
  currentStepId,
  showPreviewNav,
  showProgressBar,
}: ProgressHeaderProps) => (
  <div className="fabric-header__wrapper">
    <header
      className={cx('fabric-header', {
        frp: totalSteps < 2,
        'premium-preview-header': showPreviewNav,
        [styles.premiumPreviewHeaderNamedStepsNav]: showPreviewNav && shouldUseNamedStepsNav(),
      })}
    >
      {navElements}
    </header>
    {showProgressBar && <ProgressBar currentStepId={currentStepId} totalSteps={totalSteps} />}
  </div>
);
